<template>
  <div>
    <div class="page-title">平台账户查询</div>
    <page-search
      :layout="['code', 'name', 't_agent_info_agent_name']"
      @search="search"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      :pageSize="pageSize"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { getAccountQuery } from '@/api/settleAccounts'
import { addQuery, formatTitle } from '@/utils/common'
export default {
  name: 'accounts',
  components: {
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      col: [
        { field: 'cust_no', title: '企业编码', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 120, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        },
        { field: 'nicknamem', title: '客户名称', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'custAcctIdn', title: '出金账户账号', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'custAcctIdm', title: '入金账户账号', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'nicknamem', title: '账户名称', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'accountStatus', title: '资金账户状态', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '开户日期', width: 150, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      queryNo: '', // 搜索的企业编码
      queryName: '', // 搜索的企业名称
      t_agent_info_agent_name: '' // 渠道
    }
  },
  methods: {
    initPage() {
      this.queryNo = ''
      this.queryName = ''
      this.t_agent_info_agent_name = ''
    },
    // 获取表格数据
    getData() {
      let query = {
        per_page: this.pageSize,
        page: this.page
      }
      query = addQuery(query, 'cust_no', this.queryNo)
      query = addQuery(query, 'nicknamem', this.queryName)
      query = addQuery(query, 't_agent_info_agent_name', this.t_agent_info_agent_name)
      this.tableLoading = true
      getAccountQuery(query).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          if (res.result === undefined || res.result === null || !Array.isArray(res.result.data)) {
            this.tableData = []
            this.total = 0
          } else {
            this.tableData = res.result.data.map(item => {
              return {
                create_time: item.create_time,
                custAcctIdm: item.custAcctIdm,
                custAcctIdn: item.custAcctIdn,
                cust_no: item.cust_no,
                t_agent_info_agent_name: item.t_agent_info_agent_name,
                nickNamem: item.nickNamem,
                nicknamem: item.nicknamem,
                accountStatus: '正常'
              }
            })
            this.total = res.result.total
          }
        }
      })
    },
    // 搜索
    search(query) {
      this.queryNo = query.code || ''
      this.queryName = query.name || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.initTable()
      this.getData()
    }
  }
}
</script>

